var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('footer', [_c('div', {
    staticClass: "container text-center"
  }, [_c('div', {
    staticClass: "row py-1 py-sm-5"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-6"
  }, [_c('ul', [_c('router-link', {
    staticClass: "funko-footer-li",
    attrs: {
      "tag": "li",
      "to": "/terminos"
    }
  }, [_vm._v("Termino y Condiciones")]), _c('router-link', {
    staticClass: "funko-footer-li",
    attrs: {
      "tag": "li",
      "to": "/politicas"
    }
  }, [_vm._v("Politicas de Privacidad")])], 1)]), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-6"
  }, [_c('p', {
    staticClass: "footer-siguenos"
  }, [_vm._v("Siguenos en:")]), _c('b-icon', {
    staticClass: "m-3",
    attrs: {
      "icon": "facebook",
      "scale": "2",
      "variant": "white"
    }
  }), _c('b-icon', {
    staticClass: "m-3",
    attrs: {
      "icon": "twitter",
      "scale": "2",
      "variant": "white"
    }
  }), _c('b-icon', {
    staticClass: "m-3",
    attrs: {
      "icon": "github",
      "scale": "2",
      "variant": "white"
    }
  })], 1), _vm._m(0)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [_c('p', {
    staticClass: "footer-copyrigh"
  }, [_vm._v("Funko Pop Mania!")]), _c('p', {
    staticClass: "footer-copyrigh-symbol"
  }, [_vm._v("©")])]);
}]

export { render, staticRenderFns }